<template>
  <router-view >
    <nav class="breadcrumb" aria-label="breadcrumbs">
      <ul>
        <router-link v-slot="{ href, navigate, isActive, isExactActive }" to="/dashboard" exact>
          <li :class="[isActive && 'is-active', isExactActive && 'router-link-exact-active']">
            <a :href="href" @click="navigate">Рабочий стол</a>
          </li>
        </router-link>
        <router-link v-slot="{ href, navigate, isActive, isExactActive }" :to="`/dashboard/${$route.params.app}`" v-if="'app' in $route.params" exact>
          <li :class="[isActive && 'is-active', isExactActive && 'router-link-exact-active']">
            <a :href="href" @click="navigate">{{$tc($route.params.app)}}</a>
          </li>
        </router-link>
        <router-link v-slot="{ href, navigate, isActive, isExactActive }" :to="`/dashboard/${$route.params.app}/${$route.params.model}`" v-if="'model' in $route.params" exact>
          <li :class="[isActive && 'is-active', isExactActive && 'router-link-exact-active']">
            <a :href="href" @click="navigate">{{$tc($route.params.model)}}</a>
          </li>
        </router-link>
        <router-link v-slot="{ href, navigate, isActive, isExactActive }" :to="`/dashboard/${$route.params.app}/${$route.params.model}/${$route.params.pk || $route.name}`" v-if="'pk' in $route.params || ['create', ].includes($route.name)" exact>
          <li :class="[isActive && 'is-active', isExactActive && 'router-link-exact-active']">
            <a :href="href" @click="navigate">{{$tc($route.name)}} {{$tc($route.params.model, 0)}}</a>
          </li>
        </router-link>
      </ul>
    </nav>
  </router-view>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters('user', ['actionPermissions', 'permissions'])
  },
  methods: {
    groupLinks () {
      /*
      links = [
        {
          title
          link
          items: [
            {
              title
              link
            },
            ...
          ]
        },
        ...
      ]
      */
      const permissions = this.$store.state.user.permissions
      const links = []
      for (const [app, models] of Object.entries(permissions)) {
        const items = []
        if ('app' in this.$route.params && this.$route.params.app === app) {
          for (const [model] of Object.entries(models)) {
            items.push({
              title: this.firstUp(this.$tc(model)),
              link: `/dashboard/${app}/${model}`,
              icon: 'file'
            })
          }
        }

        links.push({
          title: this.firstUp(this.$tc(app)),
          link: `/dashboard/${app}`,
          icon: 'folder',
          items
        })
      }
      this.$store.commit('SET_DRAWER_LINKS', links)
    },
    firstUp (str) {
      return str.charAt(0).toUpperCase() + str.slice(1)
    }
  },
  watch: {
    permissions () {
      this.groupLinks()
    }
  },
  beforeUpdate () {
    this.groupLinks()
  },
  created () {
    this.groupLinks()
  },
  destroyed () {
    this.$store.commit('SET_DRAWER_LINKS', [])
  }
}
</script>
